function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-12.499 -8.332)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.03,22.341V53.472l22.859,12.7,22.859-12.7V22.341A39.019,39.019,0,0,1,43.312,16.8l-1.424-.854-1.424.854a39.018,39.018,0,0,1-21.436,5.538ZM12.5,14.865A32.515,32.515,0,0,0,37.107,11.2l4.782-2.872L46.671,11.2a32.517,32.517,0,0,0,24.607,3.661V57.314L41.889,73.644,12.5,57.314Z",
  transform: "translate(0)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.865,52.365v3.263h13.06V52.365Zm19.593-6.533v16.33H33.332V45.832Z",
  transform: "translate(-4.506 -8.111)",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M50.563,42.228V38.964a3.267,3.267,0,0,0-6.533,0v3.263ZM47.3,29.168a9.8,9.8,0,0,1,9.8,9.8v9.8H37.5v-9.8A9.8,9.8,0,0,1,47.3,29.168Z",
  transform: "translate(-5.407 -4.507)",
  fill: "currentColor"
}));

var SvgSecure = function SvgSecure(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58.779 65.312",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/secure.bad149c5.svg";
export { ForwardRef as ReactComponent };